import axios from "./axios";

export default class AgreementService {
  static createAgreement() {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/agreement/personal-data/create');
  }

  static signAgreement(agreement_id, otp) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/agreement/personal-data/sign', { agreement_id, otp });
  }
}